import { Component, Input } from '@angular/core';
import { DateTimeFormatPipe } from '../../pipes/date-time-format.pipe';
import { Order, OrderDeparture } from '../../../../../overview/models/order';

type DepartureKey = keyof OrderDeparture;

@Component({
  selector: 'app-departure',
  standalone: true,
  templateUrl: './departure.component.html',
  imports: [DateTimeFormatPipe],
  styleUrl: './departure.component.scss'
})
export class DepartureComponent {
  @Input() set order(value: Order | null) {
    if (!value || !value.routing || !value.routing.origin) {
      return;
    }
    this.dates = Object.entries(value.routing.origin)
      .filter(([key, value]) => value && Object.hasOwn(this.dateLabels, key))
      .map(([key, val]) => ({ label: this.dateLabels[key as DepartureKey], value: val as string }))
      .sort((a, b) => new Date(a.value).getTime() - new Date(b.value).getTime());
  }

  readonly dateLabels: Record<DepartureKey, string> = {
    requestedOrderReady: 'Req. Order Ready',
    currentOrderReady: 'Current Order Ready',
    originalEtd: 'Original ETD',
    currentEtd: 'Current ETD',
    requestedNewEtd: 'Req. New ETD',
    bookedEtd: 'Booked ETD',
    etdAtBookingDate: 'ETD At Booking Date'
  };
  dates: { label: string; value: string }[] = [];
}
